export default "__VITE_ASSET__BU4iY1Fe__"